__turbopack_context__.v({
  "card": "HwwygG_card",
  "caret": "HwwygG_caret",
  "caretBlink": "HwwygG_caretBlink",
  "chip": "HwwygG_chip",
  "count": "HwwygG_count",
  "cut": "HwwygG_cut",
  "del": "HwwygG_del",
  "fold": "HwwygG_fold",
  "isFresh": "HwwygG_isFresh",
  "isFreshIn": "HwwygG_isFreshIn",
  "isPeel": "HwwygG_isPeel",
  "isReset": "HwwygG_isReset",
  "letterWrap": "HwwygG_letterWrap",
  "note": "HwwygG_note",
  "noteChips": "HwwygG_noteChips",
  "peel": "HwwygG_peel",
  "trash": "HwwygG_trash",
});
